import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';
import ErroreIcon from '../Icons/ErroreIcon.js';
import { getValidation } from './index.js';

function ValidationViewer({ hasError = false, hasWarning = false, validazione, className, }) {
    const val = getValidation(validazione);
    return (jsxs(Fragment, { children: [hasError && (jsx("ul", { className: "validationViewer__errors", children: val.messages.map((x, i) => jsx("li", { children: x }, i)) })), hasError && jsx("span", { className: cns('validationViewer__icon-error', className), children: jsx(ErroreIcon, {}) }), hasWarning && (jsx("ul", { className: cns('validationViewer__warnings', className), children: val.warnings.map((x, i) => jsx("li", { children: x }, i)) })), hasWarning && (jsxs("span", { className: "validationViewer__icon-warning", children: [' ', jsx(ErroreIcon, {})] }))] }));
}

export { ValidationViewer as default };
